import { TurnRightOutlined, VisibilityOutlined } from '@mui/icons-material';
import RestoreOutlinedIcon from '@mui/icons-material/RestoreOutlined';
import {
  Box,
  Checkbox,
  Grid,
  IconButton,
  Link,
  Modal,
  Skeleton,
  Stack,
  TablePagination,
  TableSortLabel,
  Tooltip,
  Typography,
} from '@mui/material';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Edit02Icon from '@untitled-ui/icons-react/build/esm/Edit02';
import { format } from 'date-fns';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import Label from 'src/components/Label';
import loader from 'src/components/LoaderImg/loader.gif';
import useCurrentUser from 'src/hooks/use-current-user';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import ClockInOutModal from 'src/pages/therapist-dashboard/time-in-out/clock-in-out-modal';
import { paths, permissions } from 'src/paths';
import {
  editSignDocAction,
  getAllSubmittedDocument,
  getEocDocumentEditDataAction,
  resetEocDocumentEditDataAction,
  resetUuidAction,
  sendMailToPhysicianAction,
  undoDocumentSignAction,
} from 'src/redux/actions/documentationAction';
import { checkSupervisorPermission } from 'src/utils/checkSignatureAccess';
import { modalStyle } from 'src/utils/common-properties';
import useDialogVisibility from '../../utils/dialog-hide';
import { BootstrapDialog } from '../common-modals/BootstrapDialog';
import { Scrollbar } from '../scrollbar';
import SucessModal from '../sucess-modal';
import ReAssignTherapist from './re-assign-therapist';
import SelectSuperVisor from './select-supervisor';
import { useFeatureToggleWhenReady } from 'src/hooks/use-feature-toggle';
import { singleSignatureWorkflow } from 'src/config';

type Props = {
  activeTab: string;
  requireDocuments: Array<string>;
  openPrintMode: any;
  documentationDoc: any;
  setDocumentationDoc: any;
  setIsFilterApply: any;
  abortController: any;
};

const columns: any = [
  { id: 'documentType', label: 'Document Type' },
  { id: 'dateOfService', label: 'Date of Service' },
  { id: 'therapistSignature', label: 'Therapist Signature' },
  { id: 'supervisiorSignature', label: 'Supervisior Signature' },
  { id: 'physicianSignature', label: 'Physician Signature' },
  { id: 'action', label: '', align: 'right' },
];

const notSortingHeader = [
  'therapistSignature',
  'supervisiorSignature',
  'physicianSignature',
  'action',
];

const SignaturePendingList: FC<Props> = (props: Props) => {
  const {
    activeTab,
    requireDocuments,
    openPrintMode,
    documentationDoc,
    setDocumentationDoc,
    setIsFilterApply,
    abortController,
  } = props;
  const {
    patients,
    patientDetails,
    episodeOfCare,
    details,
    previewDocument,
    editDocument,
    getSignaturePreview
  } = paths;
  const navigate = useNavigate();
  const { formattedTime, isRunning, startStopwatch, stopStopwatch, time } = useStopwatch();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [providerId, discipline] = useCurrentUser(['providerId', 'discipline']);
  const episodeOfCareId = state?.episodeOfCareId;
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const getAllSignaturePending = useSelector((state: any) => state.getAllSubmittedDocumentReducer);
  const therapistDiscipline = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.discipline
  );
  const userProviderUuid = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.providerId
  );
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );
  const getSignatureAccess = useSelector((state: any) => state.getSignatureAccessReducer);
  const { UPDATE_RECERTIFICATION, READ_RECERTIFICATION, UPDATE_EVAL, READ_EVAL } = permissions;

  const thePayComeDetailsReducer = useSelector(
    (state: any) => state.thePayComeDetailsReducer?.response?.data
  );
  const getUndoSignDocResponse = useSelector((state: any) => state.editSignDocumentReducer);
  const undoDocumentSignResponse = useSelector((state: any) => state.undoDocumentSignReducer);

  const { canShowDialog: canShowClockInDialog } = useDialogVisibility('clock_in_do_not_show');
  const [isSingleSignatureWorkflow] = useFeatureToggleWhenReady(
    singleSignatureWorkflow,
    'ENTERPRISE'
  );

  //clock in modal
  const [isClockIn, setIsClockIn] = useState(false);
  const [notToShowAgain, setNotToShowAgain] = useState(false);

  const [successModal, setSuccessModal] = useState({
    success: false,
    warning: false,
  });

  const handleCloseSuccess = () => {
    setSuccessModal({
      success: false,
      warning: false,
    });
  };

  const checkoutResponse = useSelector((state: any) => state.checkoutReducer);
  const sendMailPhysicianResponse = useSelector((state: any) => state.sendMailToPhysicianReducer);

  const [triggerSelectSupervisor, setTriggerSupervisor] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [role, selectRole] = useState('');
  const [actionToBeContinue, setActionToBeContinue] = useState('');

  const [getSignatureTempDoc, setSignatureTempDoc] = useState<any>('');
  const [editDocumentData, setEditDocumentData] = useState('');

  const openSelectSupervisorModal = (document: any, role: string) => {
    setSelectedDocument(document);
    selectRole(role);
    setTriggerSupervisor(true);
  };

  const closeSupervisorModal = () => {
    setTriggerSupervisor(false);
  };

  const [openReassignTherapist, setOpenReassignTherapist] = useState(false);
  const openReassignTherapistModal = (document: any, role: string) => {
    setSelectedDocument(document);
    selectRole(role);
    setOpenReassignTherapist(true);
  };
  const closeReassignTherapistModal = () => {
    setOpenReassignTherapist(false);
  };

  const setPreviewDocument = (document: any) => {
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${previewDocument}`, {
      state: {
        document,
        episodeOfCareId,
        patientData,
      },
    });
  };

  //pagination logic

  const [rowPerPage, setRowPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [sortBy, setSortBy] = useState('dateOfService');
  const [sortOrderArray, setSortArray] = useState<any>(['desc', 'desc', 'desc', 'desc', 'desc']);

  const onPageChange = (event: any, newPage: number) => {
    dispatch(
      getAllSubmittedDocument({
        therapistUuid: providerId,
        eocId: state?.episodeOfCareId,
        signal: abortController,
        params: {
          type: activeTab,
          filter: 'PENDING',
          sortDirection: getSortOrder(sortBy),
          sortBy: sortBy,
          page: newPage,
          pageSize: rowPerPage,
        },
      })
    );
    setPage(newPage);
  };

  const getSortOrder = (sortColumn: string) => {
    switch (sortColumn) {
      case 'documentType':
        return sortOrderArray[0];
      case 'dateOfService':
        return sortOrderArray[1];
      default:
        return '';
    }
  };

  const getSortOrder1 = (sortColumn: string, newSortOrderArray: any) => {
    switch (sortColumn) {
      case 'documentType':
        return newSortOrderArray[0];
      case 'dateOfService':
        return newSortOrderArray[1];
      default:
        return '';
    }
  };

  const onRowsPerPageChange = (event: any) => {
    const newRowsPerPage = event.target.value;
    setRowPerPage(newRowsPerPage);

    dispatch(
      getAllSubmittedDocument({
        therapistUuid: providerId,
        eocId: state?.episodeOfCareId,
        signal: abortController,
        params: {
          type: activeTab,
          filter: 'PENDING',
          sortDirection: getSortOrder(sortBy),
          sortBy: sortBy,
          page: 0,
          pageSize: newRowsPerPage,
        },
      })
    );
    setPage(0);
  };
  const createSortHandler = (columnId: string, index: number) => {
    const isAsc = sortOrderArray[index] === 'asc';
    const newSortOrderArray = ['desc', 'desc', 'desc', 'desc', 'desc'];
    newSortOrderArray[index] = isAsc ? 'desc' : 'asc';

    dispatch(
      getAllSubmittedDocument({
        therapistUuid: providerId,
        eocId: state?.episodeOfCareId,
        signal: abortController,
        params: {
          type: activeTab,
          filter: 'PENDING',
          sortDirection: getSortOrder1(columnId, newSortOrderArray),
          sortBy: columnId,
          page: page,
          pageSize: rowPerPage,
        },
      })
    );
    setSortArray(newSortOrderArray);
    setSortBy(columnId);
  };

  useEffect(() => {
    if (!activeTab) return;
    setSortArray(['desc', 'desc', 'desc', 'desc', 'desc']);
    setSortBy('dateOfService');
    setPage(0);
    setRowPerPage(10);
  }, [activeTab]);

  const getSignatureTemplate = (document: any) => {
    setSignatureTempDoc(document);
    setActionToBeContinue('GET_SIGNATURE_TEMP');
    // clock in modal show
    if (
      canShowClockInDialog() &&
      !isRunning &&
      !notToShowAgain &&
      !thePayComeDetailsReducer?.enablePaycom &&
      !thePayComeDetailsReducer?.enableHostedTime &&
      !thePayComeDetailsReducer?.enablePaylocity
    ) {
      setIsClockIn(true);
      return;
    }
    //perform action here

    navigate(
      `${patients}/${patientDetails}${episodeOfCare}${details}${getSignaturePreview}`,
      {
        state: {
          document,
          episodeOfCareId,
          patientData,
        },
      }
    );
  };

  useEffect(() => {
    if (!checkoutResponse?.isGetCheckIn && checkoutResponse?.response === null) return;
    if (!checkoutResponse.isGetCheckIn && checkoutResponse?.response !== null) {
      setSuccessModal({
        success: false,
        warning: true,
      });
      return;
    }
    if (checkoutResponse.isGetCheckIn && checkoutResponse?.response !== null) {
      if (checkoutResponse?.clockAction === 'CLOCK_IN_SUCCESS') {
        if (actionToBeContinue === 'GET_SIGNATURE_TEMP') {
          navigate(
            `${patients}/${patientDetails}${episodeOfCare}${details}${getSignaturePreview}`,
            {
              state: {
                document: getSignatureTempDoc,
                episodeOfCareId,
                patientData,
              },
            }
          );
          return;
        }
        if (actionToBeContinue === 'SHOW_DOCUMENT_EDIT') {
          dispatch(resetEocDocumentEditDataAction());
          dispatch(
            getEocDocumentEditDataAction({
              document: editDocumentData,
              episodeOfCareId,
              patientData,
              activeTab,
            })
          );
          navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${editDocument}`, {
            state: {
              document: editDocumentData,
              episodeOfCareId,
              patientData,
              activeTab,
            },
          });
          return;
        }
      }
    }
  }, [checkoutResponse]);

  const showDocumentForEdit = (document: any) => {
    setEditDocumentData(document);
    setActionToBeContinue('SHOW_DOCUMENT_EDIT');
    // clock in modal show
    if (
      canShowClockInDialog() &&
      !isRunning &&
      !notToShowAgain &&
      !thePayComeDetailsReducer?.enablePaycom &&
      !thePayComeDetailsReducer?.enableHostedTime &&
      !thePayComeDetailsReducer?.enablePaylocity
    ) {
      setIsClockIn(true);
      return;
    }
    dispatch(resetEocDocumentEditDataAction());
    dispatch(
      getEocDocumentEditDataAction({
        document: document,
        episodeOfCareId,
        patientData,
        activeTab,
      })
    );
    navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${editDocument}`, {
      state: {
        document,
        episodeOfCareId,
        patientData,
        activeTab,
      },
    });
  };
  useEffect(() => {
    dispatch(resetUuidAction());
  }, []);

  const handleIsClock = () => {
    if (actionToBeContinue === 'GET_SIGNATURE_TEMP') {
      navigate(
        `${patients}/${patientDetails}${episodeOfCare}${details}${getSignaturePreview}`,
        {
          state: {
            document: getSignatureTempDoc,
            episodeOfCareId,
            patientData,
          },
        }
      );
      return;
    }
    if (actionToBeContinue === 'SHOW_DOCUMENT_EDIT') {
      dispatch(resetEocDocumentEditDataAction());
      dispatch(
        getEocDocumentEditDataAction({
          document: editDocumentData,
          episodeOfCareId,
          patientData,
          activeTab,
        })
      );
      navigate(`${patients}/${patientDetails}${episodeOfCare}${details}${editDocument}`, {
        state: {
          document: editDocumentData,
          episodeOfCareId,
          patientData,
          activeTab,
        },
      });
      return;
    }
    setNotToShowAgain(true);
    setIsClockIn(false);
  };

  type Result = {
    label: string;
    value: boolean;
  };

  const checkSignPermission = (document: any) => {
    let result: Result = {
      label: '-',
      value: false,
    };
    if (document.providerId === userProviderUuid) {
      if (document.status === 'COMPLETED') {
        result = {
          label: 'Signed',
          value: false,
        };
      } else {
        if (
          checkSupervisorPermission(getSignatureAccess.response?.data?.t1, document?.formType) &&
          document?.supervisorId
        ) {
          return {
            label: 'Sign a document',
            value: true,
          };
        } else if (
          document?.isReassigned &&
          document?.supervisorId !== null &&
          document?.supervisorStatus === 'PENDING'
        ) {
          return {
            label: 'Sign a document',
            value: true,
          };
        } else if (
          !checkSupervisorPermission(getSignatureAccess.response?.data?.t1, document?.formType)
        ) {
          return {
            label: 'Sign a document',
            value: true,
          };
        } else {
          return {
            label: '-',
            value: false,
          };
        }
      }
    }

    if (
      userProviderUuid === document.supervisorId ||
      document.formType?.includes('RECERTIFICATION') ||
      document.formType?.includes('EVALUATION')
    ) {
      if (document.status === 'PENDING') {
        result = {
          label: '-',
          value: false,
        };
      }

      if (document.status === 'COMPLETED') {
        return {
          label: 'Signed',
          value: false,
        };
      }
    }

    result = {
      label: document?.status === 'COMPLETED' ? 'Signed' : 'Pending',
      value: false,
    };

    return result;
  };

  const sendMailToPhysician = (document: any) => {
    dispatch(
      sendMailToPhysicianAction(document.supervisorId, {
        uuid: document.uuid,
      })
    );
  };

  const checkEditPermission = (document: any) => {
    if (document.providerId === null) {
      return true;
    }
    if (document.providerId !== userProviderUuid) {
      return false;
    }

    if (document.formType?.includes('DAILY_SOAP_NOTE')) {
      return false;
    }

    if (
      document.formType?.includes('RECERTIFICATION') &&
      !permissionData.includes(UPDATE_RECERTIFICATION)
    ) {
      return false;
    }
    if (document.formType?.includes('EVALUATION') && !permissionData.includes(UPDATE_EVAL)) {
      return false;
    }
    return true;
  };

  const checkReadPermission = (document: any) => {
    if (
      document.formType?.includes('RECERTIFICATION') &&
      !permissionData.includes(READ_RECERTIFICATION)
    ) {
      return false;
    }
    if (document.formType?.includes('EVALUATION') && !permissionData.includes(READ_EVAL)) {
      return false;
    }
    return true;
  };

  interface SelectSupervisiorProps {
    role: string;
    document: any;
    who: string;
  }

  const SelectSupervisior: React.FC<SelectSupervisiorProps> = ({ role, document, who }) => {
    return (
      <TableCell sx={{ cursor: 'pointer' }}>
        {document?.supervisorName ? (
          <>
            {role.toLowerCase() === who ? (
              <Typography variant="caption">{document?.supervisorName}</Typography>
            ) : (
              <Typography variant="caption">Not Required</Typography>
            )}

            {role === 'Supervisor' &&
              who === 'supervisor' &&
              (document?.supervisorStatus === 'COMPLETED' || document?.status === 'PENDING' ? (
                <Label
                  backgroundColor="#F790091F"
                  color="#B54708"
                  text={
                    document?.supervisorStatus?.slice(0, 1) +
                    document?.supervisorStatus
                      ?.slice(1, document?.supervisorStatus.length)
                      .toLowerCase()
                  }
                />
              ) : document.supervisorId === userProviderUuid ? (
                <Link
                  display={'inline'}
                  onClick={() => getSignatureTemplate(document)}
                >
                  <Typography variant="body2">Sign a document</Typography>
                </Link>
              ) : (
                <Label
                  backgroundColor="#F790091F"
                  color="#B54708"
                  text={'Pending'}
                />
              ))}

            {!isSingleSignatureWorkflow && role === 'Physician' &&
              role.toLowerCase() === who &&
              document.status === 'COMPLETED' &&
              (!document?.mailSentToPhysician && document?.providerId === userProviderUuid ? (
                <Typography variant="body2">
                  <Link onClick={() => sendMailToPhysician(document)}>Send a mail</Link>
                </Typography>
              ) : (
                <>
                  <Stack
                    gap="4px"
                    flexDirection="row"
                    mt={1}
                  >
                    <Label
                      backgroundColor="#F790091F"
                      color="#B54708"
                      text="Pending"
                    />
                    {document?.mailSentToPhysician === true &&
                      document?.supervisorStatus === 'PENDING' && (
                        <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                          <Typography variant="body2">
                            <Link
                              sx={{
                                pointerEvents: sendMailPhysicianResponse?.isLoading
                                  ? 'none'
                                  : 'auto',
                                color: sendMailPhysicianResponse?.isLoading ? '#bbc1cac4' : 'none',
                              }}
                              onClick={() => sendMailToPhysician(document)}
                            >
                              Resend Mail
                            </Link>
                          </Typography>
                        </Box>
                      )}
                  </Stack>
                </>
              ))}
          </>
        ) : checkSupervisorPermission(getSignatureAccess.response?.data?.t1, document?.formType) &&
          document.supervisorStatus !== null &&
          document.providerId === userProviderUuid ? (
          who === role.toLowerCase() ? (
            <Link onClick={() => openSelectSupervisorModal(document, role)}>Select {role}</Link>
          ) : (
            <Typography variant="caption">Not Required</Typography>
          )
        ) : who === checkWhosSignNeed(document).toLowerCase() &&
          document?.supervisorStatus !== null ? (
          <Typography variant="caption">Pending to be Assigned</Typography>
        ) : (
          <Typography variant="caption">Not Required</Typography>
        )}
      </TableCell>
    );
  };

  const checkWhosSignNeed = (document: any) => {
    if (
      document?.documentType.toLowerCase().includes('evaluation') ||
      document?.documentType.toLowerCase().includes('recertification')
    ) {
      return 'Physician';
    } else {
      return 'Supervisor';
    }
  };

  const HandleStartClock = () => {
    const millageInfo = {
      locationType: 'BUILDING',
      payByMilage: null,
    };
    startStopwatch('MILLAGE', millageInfo);
  };

  const onSelectAllClickPendingSign = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsFilterApply(false);
    if (event.target.checked) {
      setDocumentationDoc((prev: any) => ({
        ...prev,
        signaturePending: requireDocuments,
      }));
      return;
    }
    setDocumentationDoc((prev: any) => ({
      ...prev,
      signaturePending: [],
    }));
  };

  const checkUndoPermisiion = (document: any) => {
    if (document.providerId === userProviderUuid && document.status === 'COMPLETED') {
      return true;
    }
    return false;
  };

  const removedSignDocument = (document: any) => {
    if (document?.isReformSignature && isSingleSignatureWorkflow) {
      dispatch(
        undoDocumentSignAction({
          formSubmissionUuid: document.uuid,
          documentType: document?.documentType?.replaceAll(' ', '_')?.toUpperCase(),
        })
      );
      return;
    } else {
      dispatch(
        editSignDocAction(document.uuid, {
          submissionId: document.submissionId,
          isForSupervisor: Boolean(document?.supervisorId),
          formType: document?.formType,
        })
      );
    }
  };

  const handleNavigateToDailySessionNote = (document: any) => {
    const selectedPatientData = {
      name: patientData?.name,
      uuid: patientData?.uuid,
      firstName: patientData?.firstName,
      lastName: patientData?.lastName,
      notesId: patientData?.dailySessionNoteUuid,
    };
    navigate('/daily-session-notes', {
      state: {
        document: {
          dateOfService: document?.dateOfService,
          source: 'FROM_EOC',
          dailySessionNoteUuid: document?.dailySessionNoteUuid,
          patientEoc: selectedPatientData,
        },
      },
    });
  };
  return (
    <>
      <Box
        // sx={{ border: '1px solid #F2F4F7', borderRadius: '20px' }}
        p={3}
      >
        <Card>
          <Grid
            container
            sx={{ padding: '18px 24px 18px 24px', position: 'relative' }}
          >
            <Typography variant="h6">Signature Pending</Typography>

            <Box
              sx={{
                border: '1px solid rgba(0, 0, 0, 0.26)',
                borderRadius: '12px',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                marginLeft: '12px',
              }}
            >
              <Typography sx={{ color: '#111927', fontSize: '13px', letterSpacing: '0.16px' }}>
                {`${
                  getAllSignaturePending?.response?.totalElements
                    ? getAllSignaturePending?.response?.totalElements
                    : 0
                } Document`}
              </Typography>
            </Box>
          </Grid>
          <Divider />
          <Scrollbar>
            <Table sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  {columns?.map((column: any, index: any) => (
                    <TableCell
                      key={column.id}
                      align={column?.align}
                    >
                      {!notSortingHeader.includes(column?.id) ? (
                        <>
                          {openPrintMode && column?.id === 'documentType' ? (
                            <Checkbox
                              color="primary"
                              indeterminate={
                                documentationDoc?.signaturePending?.length > 0 &&
                                documentationDoc?.signaturePending?.length <
                                  requireDocuments?.length
                              }
                              checked={
                                requireDocuments?.length > 0 &&
                                documentationDoc?.signaturePending?.length ===
                                  requireDocuments?.length
                              }
                              onChange={onSelectAllClickPendingSign}
                              inputProps={{
                                'aria-label': 'select all desserts',
                              }}
                            />
                          ) : null}
                          <TableSortLabel
                            active={true}
                            direction={sortOrderArray[index]}
                            onClick={() => createSortHandler(column.id, index)}
                          >
                            {column.label}
                          </TableSortLabel>
                        </>
                      ) : (
                        column.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {getAllSignaturePending?.loader ? (
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Box
                        textAlign="center"
                        p={3}
                      >
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                        <Skeleton animation="wave" />
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : getAllSignaturePending?.response?.totalElements ? (
                  requireDocuments?.map((document: any) => (
                    <TableRow
                      key={document.uuid}
                      sx={{
                        backgroundColor: documentationDoc?.signaturePending?.some(
                          (item: any) => item?.uuid === document?.uuid
                        )
                          ? '#EBEEFE'
                          : null,
                      }}
                      onClick={() => {
                        if (openPrintMode) {
                          setIsFilterApply(false);
                          const chipIndex = documentationDoc?.signaturePending?.find(
                            (chip: any) => chip?.uuid === document?.uuid
                          );
                          if (chipIndex) {
                            const updatedChips = documentationDoc?.signaturePending?.filter(
                              (chip: any) => chip?.uuid !== document?.uuid
                            );

                            setDocumentationDoc((prev: any) => ({
                              ...prev,
                              signaturePending: updatedChips,
                            }));
                            return;
                          } else {
                            setDocumentationDoc((prev: any) => ({
                              ...prev,
                              signaturePending: [...documentationDoc?.signaturePending, document],
                            }));
                          }
                          return;
                        }
                      }}
                    >
                      <TableCell>
                        <Grid
                          container
                          alignItems="center"
                          direction="row"
                        >
                          {openPrintMode ? (
                            <Checkbox
                              checked={documentationDoc?.signaturePending?.some(
                                (item: any) => item?.uuid === document?.uuid
                              )}
                            />
                          ) : null}
                          <Typography
                            variant="subtitle2"
                            sx={{ marginLeft: '4px' }}
                          >
                            {document.documentType}
                          </Typography>
                        </Grid>
                      </TableCell>
                      <TableCell>
                        {document.dateOfService
                          ? format(
                              new Date(
                                new Date(document.dateOfService).valueOf() +
                                  new Date(document.dateOfService).getTimezoneOffset() * 60 * 1000
                              ),
                              'dd MMM, yyyy'
                            )
                          : '-'}
                      </TableCell>
                      <TableCell
                        sx={{
                          cursor: checkSignPermission(document).value ? 'pointer' : 'default',
                        }}
                      >
                        <Typography
                          variant="caption"
                          display={'inline'}
                        >
                          {document.signedBy ? (
                            document.signedBy[0]
                          ) : (
                            <Link onClick={() => openReassignTherapistModal(document, role)}>
                              <Typography
                                variant="body2"
                                sx={{ cursor: 'pointer' }}
                              >
                                Re-assign Therapist
                              </Typography>
                            </Link>
                          )}
                        </Typography>
                        {checkSignPermission(document).value ? (
                          <Link
                            display={'inline'}
                            onClick={() => getSignatureTemplate(document)}
                          >
                            <Typography variant="body2">
                              {checkSignPermission(document).label}
                            </Typography>
                          </Link>
                        ) : checkSignPermission(document).label === 'Signed' ? (
                          <Label
                            backgroundColor="#15B79E1F"
                            color="#107569"
                            text="Signed"
                          />
                        ) : (
                          <Label
                            backgroundColor="#F790091F"
                            color="#B54708"
                            text="Pending"
                          />
                        )}
                        {document.signedBy &&
                          !document?.isReassigned &&
                          document?.status !== 'COMPLETED' &&
                          document?.formType !== 'DAILY_SOAP_NOTE' && (
                            <Link onClick={() => openReassignTherapistModal(document, role)}>
                              <Typography
                                variant="body2"
                                sx={{ cursor: 'pointer' }}
                              >
                                Re-assign Therapist
                              </Typography>
                            </Link>
                          )}
                      </TableCell>
                      <TableCell>
                        <SelectSupervisior
                          role={checkWhosSignNeed(document)}
                          document={document}
                          who={'supervisor'}
                        />
                      </TableCell>
                      <TableCell>
                        <SelectSupervisior
                          role={checkWhosSignNeed(document)}
                          document={document}
                          who={'physician'}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {document?.formType === 'DAILY_SOAP_NOTE' &&
                          document?.providerId === providerId && (
                            <Tooltip
                              placement="top"
                              title="Go to session notes"
                            >
                              <IconButton
                                onClick={() => handleNavigateToDailySessionNote(document)}
                              >
                                <TurnRightOutlined />
                              </IconButton>
                            </Tooltip>
                          )}
                        {document.pdfUrl && checkReadPermission(document) && (
                          <IconButton onClick={() => setPreviewDocument(document)}>
                            <VisibilityOutlined />
                          </IconButton>
                        )}

                        {therapistDiscipline === document?.type &&
                          checkEditPermission(document) &&
                          document.status === 'PENDING' && (
                            <IconButton onClick={() => showDocumentForEdit(document)}>
                              <Edit02Icon />
                            </IconButton>
                          )}

                        {checkUndoPermisiion(document) && (
                          <IconButton
                            title="Undo Signature"
                            onClick={() => removedSignDocument(document)}
                          >
                            {undoDocumentSignResponse.loading || getUndoSignDocResponse?.loading ? (
                              <img
                                src={loader}
                                alt="loading"
                                style={{ height: 40 }}
                              />
                            ) : (
                              <RestoreOutlinedIcon />
                            )}
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Box
                        textAlign="center"
                        p={3}
                      >
                        <Typography
                          color={'text.secondary'}
                          variant="subtitle2"
                        >
                          No Records Found
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Scrollbar>
          <TablePagination
            component="div"
            count={getAllSignaturePending?.response?.totalElements || 0}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowPerPage}
            rowsPerPageOptions={[10, 15, 30]}
          />
        </Card>
      </Box>
      {/* clock in modal */}
      {canShowClockInDialog() && (
        <BootstrapDialog
          PaperProps={{ style: { maxWidth: '750px' } }}
          onClose={() => setIsClockIn(false)}
          aria-labelledby="customized-dialog-title"
          open={isClockIn && !notToShowAgain}
        >
          <ClockInOutModal
            close={handleIsClock}
            handleClockIn={HandleStartClock}
          />
        </BootstrapDialog>
      )}

      {/* success modal */}

      <Modal open={successModal?.success || successModal?.warning}>
        <SucessModal
          close={handleCloseSuccess}
          isSucess={successModal.success}
          title={successModal?.success ? 'Clock In successfully' : 'Clock in Failed'}
          message=""
        />
      </Modal>

      {/* For selecting a supervisor */}
      <Modal
        style={modalStyle}
        open={triggerSelectSupervisor}
        onClose={closeSupervisorModal}
      >
        <div>
          <SelectSuperVisor
            activeTab={activeTab}
            close={closeSupervisorModal}
            selectedDocument={selectedDocument}
            role={role}
          />
        </div>
      </Modal>

      {/* For re-assign therapist */}
      <Modal
        style={modalStyle}
        open={openReassignTherapist}
        onClose={closeReassignTherapistModal}
      >
        <div>
          <ReAssignTherapist
            activeTab={activeTab}
            close={closeReassignTherapistModal}
            selectedDocument={selectedDocument}
            role={role}
          />
        </div>
      </Modal>
    </>
  );
};

export default SignaturePendingList;
